import type { UseQueryResult } from "@tanstack/react-query";
import type { Read } from "@/components/ui/box.schema";
import { inboxWords as words } from "./inbox-copy";

/** A failed refresh retains the last read; an unread value is never an empty collection. */
export function inboxRead<T>(query: UseQueryResult<T>, sentence: string): Read<T> {
  if (query.data !== undefined) {
    const readAt = new Date(query.dataUpdatedAt).toISOString();
    if (query.isError) return {status:"stale",last:query.data,readAt,sentence:words.stale,refresh:()=>void query.refetch()};
    return {status:"ready",value:query.data,readAt};
  }
  if (query.isError) return {status:"failed",sentence,retry:()=>void query.refetch()};
  return {status:"loading"};
}
